import { render, staticRenderFns } from "./ProductQuantityDiscountB2b.vue?vue&type=template&id=82b11ef2"
import script from "./ProductQuantityDiscountB2b.vue?vue&type=script&lang=js"
export * from "./ProductQuantityDiscountB2b.vue?vue&type=script&lang=js"
import style0 from "./ProductQuantityDiscountB2b.vue?vue&type=style&index=0&id=82b11ef2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports